import { render, staticRenderFns } from "./commonFlexBox.vue?vue&type=template&id=4c1945e0&scoped=true"
import script from "./commonFlexBox.vue?vue&type=script&lang=js"
export * from "./commonFlexBox.vue?vue&type=script&lang=js"
import style0 from "./commonFlexBox.vue?vue&type=style&index=0&id=4c1945e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1945e0",
  null
  
)

export default component.exports